export const meetingsAndEvents = [
  {
    id: "event01112021",
    type: "event",
    borderColor: "#005EB8",
    date: "01 Nov 2021",
    timeFrom: "13:00",
    timeTo: "14:30",
    title: "Board Meeting",
    text: "<p>Lorem ipsum dolor sit amet, consect adipiscing elit. Morbi in finibus mauris, eu varius mauris. Sed luctus ipsum non varius placerat.</p><p>First Tuesday of each month</p>",
  },
  {
    id: "event25112021",
    type: "event",
    borderColor: "#005EB8",
    date: "25 Nov 2021",
    title: "Scheduled Training",
    text: "<p>Mandatory Bluestream Training for all new staff members</p>",
  },
  {
    id: "event28112021",
    type: "event",
    borderColor: "#005EB8",
    date: "28 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event29112021",
    type: "event",
    borderColor: "#005EB8",
    date: "29 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event30112021",
    type: "event",
    borderColor: "#005EB8",
    date: "30 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event01122021",
    type: "event",
    borderColor: "#005EB8",
    date: "01 Dec 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  }
]
export const meetingsMinutes = [
  {
    id: "minutes07092021",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "Board Meeting",
    link: "/",
  },
  {
    id: "minutes07092022",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "New Staff Member",
    link: "/",
  },
  {
    id: "minutes07092023",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092024",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092025",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092026",
    type: "minutes",
    borderColor: "#C0007C",
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  }
]
export const news = [
  {
    id: "news07092021",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "New Staff Member",
    text: "<p>Lorem ipsum dolor sit amet, consect adipiscing elit. Morbi in finibus mauris, eu varius mauris. Sed luctus ipsum non varius placerat.</p>",
    imageUrl: "new-staff-member.png"
  },
  {
    id: "news07092021_2",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    imageUrl: "service-added.png"
  },
  {
    id: "news07092021_3",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    imageUrl: "service-added.png"
  }, 
  {
    id: "news07092021_4",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    imageUrl: "service-added.png"
  }, 
  {
    id: "news07092021_5",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    imageUrl: "service-added.png"
  }, 
  {
    id: "news07092021_6",
    type: "news",
    media: true,
    borderColor: "#715BFF",
    date: "07 Sep 2020",
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    imageUrl: "service-added.png"
  } 
]
export const videos = [
  {
    id: "video07092021",
    type: "video",
    media: true,
    borderColor: "#07A7F0",
    date: "07 Sep 2020",
    title: "Optimising your EMIS Web configurations",
    videoUrl: 'https://www.youtube.com/watch?v=KSM0lLbVYOo'
  },
  {
    id: "video07092022",
    type: "video",
    media: true,
    borderColor: "#07A7F0",
    date: "20 Aug 2020",
    title: "Safer and more efficient community care with EMIS Web",
    videoUrl: 'https://www.youtube.com/watch?v=7E0fVfectDo'
  },  
  {
    id: "video07092023",
    type: "video",
    media: true,
    borderColor: "#07A7F0",
    date: "07 Sep 2020",
    title: "Optimising your EMIS Web configurations",
    videoUrl: 'https://www.youtube.com/watch?v=nhDdn86AoXs'
  },
  {
    id: "video07092024",
    type: "video",
    media: true,
    borderColor: "#07A7F0",
    date: "20 Aug 2020",
    title: "Safer and more efficient community care with EMIS Web",
    videoUrl: 'https://www.youtube.com/watch?v=W85oD8FEF78'
  }  
]
export const keyTopics = {
  placeholder: "Select a topic",
  options: [
    {
      name: "Topic 1",
      link: "/"
    },
    {
      name: "Topic 2",
      link: "/"
    },
    {
      name: "Topic 3",
      link: "/"
    }
  ]
}
export const keyPathways =  {
  placeholder: "Select a pathways",
  options: [
    {
      name: "Pathway 1",
      link: "/"
    },
    {
      name: "Pathway 2",
      link: "/"
    },
    {
      name: "Pathway 3",
      link: "/"
    }
  ]
}
export const keyServices = {
  placeholder: "Select a service",
  options: [
    {
      name: "Service 1",
      link: "/"
    },
    {
      name: "Service 2",
      link: "/"
    },
    {
      name: "Service 3",
      link: "/"
    }
  ]
}
export const prescribingGuidelines = {
  placeholder: "Selecting a prescribing guideline",
  options: [
    {
      name: "Prescribing guideline 1",
      link: "/"
    },
    {
      name: "Prescribing guideline 2",
      link: "/"
    },
    {
      name: "Prescribing guideline 3",
      link: "/"
    }
  ]
}
export const sharedCareGuidelines = {
  placeholder: "Selecting a shared care guideline",
  options: [
    {
      name: "Shared care guideline 1",
      link: "/"
    },
    {
      name: "Shared care guideline 2",
      link: "/"
    },
    {
      name: "Shared care guideline 3",
      link: "/"
    }
  ]
}
export const memberPractices = [
  {
    id: "practice7092022",
    type: "memberPractice",
    media: true,
    title: "The Pheonix Practice",
  },
  {
    id: "practice7092023",
    type: "memberPractice",
    media: true,
    title: "Dr Azim and Partners",
  },
  {
    id: "practice7092024",
    type: "memberPractice",
    media: true,
    title: "Pennine Drive Medical Centre",
  },
  {
    id: "practice7092025",
    type: "memberPractice",
    media: true,
    title: "Hill View Surgery",
  },
  {
    id: "practice7092026",
    type: "memberPractice",
    media: true,
    title: "St Georges Medical Centre",
  },
  {
    id: "practice7092027",
    type: "memberPractice",
    media: true,
    title: "Ravenscroft Medical Centre",
  },
  {
    id: "practice7092028",
    type: "memberPractice",
    media: true,
    title: "Green Fields Medical Centre",
  },
  {
    id: "practice7092029",
    type: "memberPractice",
    media: true,
    title: "Cricklewood Health Centre",
  }
]
export const staffMembers = [
  {
    id: "practice7092022",
    type: "staffMembers",
    role: "Admin lead",
    title: "Shane Payen",
    email: "shane.payen@nhs.net"
  },
  {
    id: "practice7092023",
    type: "staffMembers",
    role: "Care coordinator",
    title: "Ellie Hatch-Mccarthy",
    email: "ellie.hatch-mccarthy@nhs.net"
  },
  {
    id: "practice7092024",
    type: "staffMembers",
    role: "Clinical Director",
    title: "Nayeem Azim",
    email: "nayeemazim@nhs.net"
  },
  {
    id: "practice7092025",
    type: "staffMembers",
    role: "Dementia",
    title: "Wadzanai chamboko",
    email: "wadzanai.chamboko@nhs.net"
  },
  {
    id: "practice7092026",
    type: "staffMembers",
    role: "Dietician",
    title: "Judith Aslan",
    email: "judith.aslan1@nhs.net"
  },
  {
    id: "practice7092027",
    type: "staffMembers",
    role: "Health and Wellbeing Coach",
    title: "Waheeda Hewad",
    email: "waheeda.hewad@nhs.net"
  },
  {
    id: "practice7092028",
    type: "staffMembers",
    role: "MSK Practitioner",
    title: "Ghulam Adel",
    email: "ghulam.adel@nhs.net"
  },
  {
    id: "practice7092029",
    type: "staffMembers",
    role: "PCN Manager",
    title: "Abrahim Azim",
    email: "Abrahim.azim@nhs.net"
  },
  {
    id: "practice7092030",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Ahmed Sherman",
    email: "ahmed.sherman@nhs.net"
  },
  {
    id: "practice7092031",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Aisha Noor",
    email: "a.noor@nhs.net"
  },
  {
    id: "practice7092032",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Bhavesha Jiwan",
    email: "bhavesha.jiwan@nhs.net"
  },
  {
    id: "practice7092033",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Hamdi Moallim",
    email: "hamdi.moallim@nhs.net"
  },
  {
    id: "practice7092034",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Mayra Sherman",
    email: "mayra.sherman1@nhs.net"
  },
  {
    id: "practice7092035",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Minal Shah",
    email: "minal.shah@nhs.net"
  },
  {
    id: "practice7092037",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Sabbir Ahmed",
    email: "sabbir.ahmed@nhs.net"
  },
  {
    id: "practice7092038",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Tejal Gor",
    email: "t.gor@nhs.net"
  },
  {
    id: "practice7092039",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Emma hatfield",
    email: "emma.hatfield4@nhs.net"
  },
  {
    id: "practice7092040",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Inass Ibrahim",
    email: "inass.ibrahim@nhs.net"
  },
  {
    id: "practice7092041",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Rebeqa Lovett",
    email: "rebeqa.lovett@nhs.net"
  }
]